import React, { createContext, useContext, useMemo } from 'react';

const DragPreviewContext = createContext<boolean>(false);

export const useDragPreview = () => useContext(DragPreviewContext);

export const DragPreviewProvider: React.FC<{
  isPreview: boolean;
  children: React.ReactNode;
}> = ({ isPreview, children }) => {
  const value = useMemo(() => isPreview, [isPreview]);
  return (
    <DragPreviewContext.Provider value={value}>
      {children}
    </DragPreviewContext.Provider>
  );
};
